import { Component, Inject } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrl: './send-email.component.scss'
})
export class SendEmailComponent {

  constructor(
    private readonly commonService: CommonService,
    public dialogRef: MatDialogRef<SendEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userGpid: string; systemId: string; id: string }
  ) { }

  email = {
    from: '',
    to: '',
    subject: '',
    message: 'Please see attached invoice copy for your records'
  };

  ngOnInit(): void {
    this.getEmailInfo();
  }

  getEmailInfo(): void {
    this.commonService.getLinkEmailInfo(this.data.userGpid, this.data.systemId, this.data.id)
      .subscribe({
        next: (response) => {
          console.log('Email info fetched:', response);
          this.email = {
            ...this.email, // preserve existing message
            from: response.fromAddress || '',
            to: response.toAddress || '',
            subject: response.subject || ''
          };
        },
        error: (err) => {
          console.error('Failed to fetch email info:', err);
        }
      });
  }

  onSubmit() {
    const payload = {
      userGpid: this.data.userGpid,
      systemId: parseInt(this.data.systemId),
      fromAddress: this.email.from,
      toAddress: this.email.to,
      subject: this.email.subject,
      message: this.email.message
    };

    this.commonService.sendEmail(payload, this.data.id).subscribe({
      next: (res) => {
        this.commonService.showMessage('Email sent.', 'success');
        this.dialogRef.close('success');
      },
      error: (err) => {
        this.commonService.showMessage('Error in sending Email.', 'error');
      }
    });
  }

  onCancel(): void {
    this.email = {
      from: '',
      to: '',
      subject: '',
      message: 'Please see attached invoice copy for your records'
    };
    this.dialogRef.close('cancelled');
  }
}
